const isTenaStore = document.body.classList.contains('tena-store');
const {
  byob_tier1_qty,
  byob_tier2_qty,
  byob_tier3_qty,
  byob_tier1_discount,
  byob_tier2_discount,
  byob_tier3_discount
} = theme.settings;

const discounts = {
  [byob_tier1_qty]: byob_tier1_discount,
  [byob_tier2_qty]: byob_tier2_discount,
  [byob_tier3_qty]: byob_tier3_discount
};

let bodyHandlerTimeout = null;
function setBodyPaddingHandler() {
  clearTimeout(bodyHandlerTimeout);

  bodyHandlerTimeout = setTimeout(() => {
    window.innerWidth <= 768 ?
      document.body.style.paddingBottom = '60px' :
      document.body.style.paddingBottom = '0px';
  }, 500)
}

document.body.addEventListener('click', (e) => {
  const byobWidget = document.querySelector('.byob__widget');

  if (!e.target.closest('.byob__widget')) {
    document.body.classList.remove('overflow');
    byobWidget.classList.remove('is--open');
  }

  if (e.target.closest('.byob__widget-toggle') && window.innerWidth <= 768) {
    document.body.classList.toggle('overflow');
    byobWidget.classList.toggle('is--open');
  }

  if (e.target.closest('.byob__item-remove')) {
    bundleItemsHandler(e.target.closest('.byob__item-remove').dataset.uniqId, 'REMOVE');
    setMaxHeightHandler();
  }

  if (e.target.closest('.byobbtn')) {
    const targetElement = e.target.closest('.byobbtn');
    const pid = targetElement.dataset.byobProductId || targetElement.getAttribute('data-byob-product-id') || targetElement.dataset.productId || targetElement.getAttribute('data-product-id');

    // If variantId is missing, attempt to resolve a variant directly from productVariantsData or by title
    if (!targetElement.dataset.variantId || targetElement.dataset.variantId === '') {
      // First try a direct lookup from variant JSON (more reliable than relying on popup handlers)
      try {
        const rawTitle = targetElement.getAttribute('data-variant-title') || targetElement.dataset.variantTitle || '';
        let found = null;
        if (pid && window.productVariantsData && window.productVariantsData[pid]) {
          try {
            // Try to find the best matching variant from the productVariantsData
            if (typeof window.byobFindVariantByTitle === 'function') {
              found = window.byobFindVariantByTitle(pid, rawTitle);
            }
          } catch (e) {}
          if (found) {
            // populate dataset directly from found variant
            targetElement.dataset.variantId = found.id;
            targetElement.dataset.price = found.price;
            targetElement.dataset.variantImage = found.featured_image?.src || '';
            // try to extract color/size from the variant options
            targetElement.dataset.colorName = found.option1 || '';
            targetElement.dataset.sizeName = found.option2 || '';
          }
        }

        // If still not found, fall back to the popup auto-select and wait a short moment
        if (!targetElement.dataset.variantId) {
          if (pid && typeof window.byobAutoSelectFromVariantTitle === 'function') {
            try { window.byobAutoSelectFromVariantTitle(pid); } catch (e) {}
          }
        }
      } catch (e) { /* ignore */ }

      // Delay the actual add slightly to allow dataset to populate (either by direct set above or by popup handlers)
      setTimeout(() => {
        bundleListHandler({
          id: targetElement.dataset.variantId,
          image: targetElement.dataset.variantImage,
          price: targetElement.dataset.price,
          productTitle: targetElement.dataset.eventLabel,
          colorTitle: targetElement.dataset.colorName,
          sizeTitle: targetElement.dataset.sizeName
        });
        setMaxHeightHandler();
      }, 80);
    } else {
      // Already populated — proceed immediately
      bundleListHandler({
        id: targetElement.dataset.variantId,
        image: targetElement.dataset.variantImage,
        price: targetElement.dataset.price,
        productTitle: targetElement.dataset.eventLabel,
        colorTitle: targetElement.dataset.colorName,
        sizeTitle: targetElement.dataset.sizeName
      });
      setMaxHeightHandler();
    }
  }

  if (e.target.closest('.byob__widget-button')) {
    addToCartHandler();
  }
});

// We use setTimeout to call this function only once
let maxHeightHandlerTimeout;
const maxPerViewItems = 7;
function setMaxHeightHandler() {
  clearTimeout(maxHeightHandlerTimeout);
  maxHeightHandlerTimeout = setTimeout(() => {
    const byobItems = document.querySelectorAll('.byob__widget-list .byob__item');
    const byobList = document.querySelector('.byob__widget-list');
    if (byobItems.length > maxPerViewItems) {
      const firstElements = Array.from(byobItems).slice(0, maxPerViewItems);

      let totalHeight = 0;

      for (let i = 0; i < maxPerViewItems; i++) {
        totalHeight += firstElements[i].offsetHeight + 8;
      }
      byobList.style.maxHeight = `${totalHeight + 15}px`;
    } else {
      byobList.style.maxHeight = `initial`;
    }
  }, 300)
}

document.addEventListener('DOMContentLoaded', setBodyPaddingHandler);
window.addEventListener('resize', () => {
  setMaxHeightHandler();
  setBodyPaddingHandler();
});
window.addEventListener('orientationchange', () => {
  setBodyPaddingHandler();
  setMaxHeightHandler();
});

let addedBundleItems = [];

function moneyFormatHandler(money) {
  return `${productMoneySymbol}${(money / 100).toFixed(2)}`;
}

function setlocalStorageHandler() {
  localStorage.setItem('byob_items', JSON.stringify(addedBundleItems));
}

function getLocalStorageHandler(isAjaxRender) {
  const oldBundleItems = JSON.parse(localStorage.getItem('byob_items'));
  if (oldBundleItems) {
    oldBundleItems.forEach(byobItems => {
      const { id, image, price, productTitle, colorTitle, sizeTitle, uniqId } = byobItems;
      bundleListHandler({ id, image, price, productTitle, colorTitle, sizeTitle, uniqId }, true, isAjaxRender)
    });
  }

  const fetchedCount = Array.isArray(oldBundleItems) ? oldBundleItems.length : 0;
  progressbarMessageHandler(fetchedCount);
  progressBarHandler(fetchedCount);

  setMaxHeightHandler();
}
getLocalStorageHandler();
// We need this to render content after filering
window.byobGlobalHandler = getLocalStorageHandler;

function discountsHandler() {
  const byobItemsQuantity = addedBundleItems.length;
  let lastDiscountKey = null;

  const keys = Object.keys(discounts);
  for (const key of keys) {
    if (byobItemsQuantity >= key) lastDiscountKey = key;
  }

  addedBundleItems.forEach(byobItem => {
    if (lastDiscountKey) byobItem.comparePrice = byobItem.price - byobItem.price * (discounts[lastDiscountKey] / 100);
    else delete byobItem.comparePrice;
  })

  addedBundleItems.forEach(byobItem => {
    const byobItemPriceContainer = document.querySelector(`[data-uniq-id="${byobItem.uniqId}"] .byob__item-price`);
    if (byobItemPriceContainer) {
      const oldComparePrice = byobItemPriceContainer.querySelector('.byob__item-price_sale');
      oldComparePrice && oldComparePrice.remove();

      if (byobItem.comparePrice) {
        byobItemPriceContainer.classList.add('has-compare');
        byobItemPriceContainer.innerHTML += `<div class="byob__item-price_sale">${moneyFormatHandler(byobItem.comparePrice)}</div>`
      } else {
        byobItemPriceContainer.classList.remove('has-compare');
      }
    }
  })
}

function removeBundleItemHandler(uniqIdValue) {
  const indexToRemove = addedBundleItems.findIndex(item => +uniqIdValue === item.uniqId);
  if (indexToRemove != -1) {
    addedBundleItems.splice(indexToRemove, 1);
    const removedBundleItem = document.querySelector(`[data-uniq-id="${uniqIdValue}"]`);
    removedBundleItem && removedBundleItem.remove();
  }
}

function submitButtonPriceHandler() {
  const submitButton = document.querySelector('.byob__widget-button');
  if (!submitButton) return;

  const buttonTextElement = submitButton.querySelector('span');
  if (!buttonTextElement) return;
  const defaultText = submitButton.dataset.text || 'Add to cart';
  // Calculate final price using reduce
  const finalPrice = (addedBundleItems && addedBundleItems.length > 0)
    ? addedBundleItems.reduce((total = 0, item) => {
      const price = Number(item.comparePrice ?? item.price);
      return total + +(price / 100).toFixed(2);
    }, 0)
    : 0;

  // Update button state and text
  if (finalPrice > 0) {
    submitButton.classList.remove('no-products');
    buttonTextElement.innerText = `${defaultText} ${productMoneySymbol}${finalPrice.toFixed(2)}`;
  } else {
    submitButton.classList.add('no-products');
    buttonTextElement.innerText = defaultText;
  }
}

let isLoad = false;
window.addEventListener('load', () => {
  isLoad = true;
})

function bundleItemsHandler(data, action, isLoadPage, isAjaxRender) {
  switch (action) {
    case 'ADD':
      const activePopup = document.querySelector('.variant-popup.active-popup');
      if (activePopup && isLoad && window.innerWidth <= 768) {
        setTimeout(() => {
          // A small transition before opening the main widget
          activePopup.querySelector('.close-popup').click();
          document.querySelector('.byob__widget-toggle').click();
        }, 500);
      }
      if (!isAjaxRender) addedBundleItems.push(data)
      break;
    case 'REMOVE':
      removeBundleItemHandler(data);

    default:
      break;
  }

  if (!isLoadPage) {
    setlocalStorageHandler();
    handleByobItemCount();
  }

  discountsHandler();
  submitButtonPriceHandler();
}

function bundleListHandler(data, isLoadPage, isAjaxRender) {
  const byobBundleList = document.querySelector('.byob__widget-list');
  let { id, image, price, productTitle, colorTitle, sizeTitle, uniqId: newUniqId } = data;
  let productTitleText = productTitle;

  colorTitle = colorTitle;
  // Display-only value
  const displayColorTitle =
    colorTitle.length > 6
      ? `${colorTitle.substring(0, 6).trim()}...`
      : colorTitle;

  const bundleItem = document.createElement('li');
  let uniqId = newUniqId ? newUniqId : Date.now();
  bundleItem.setAttribute('data-uniq-id', uniqId);
  bundleItem.setAttribute('data-origin-price', price);
  bundleItem.classList.add('byob__item');
  bundleItem.innerHTML = `
    <div class="byob__item-image">
      <img src="${image}" alt="${productTitle}" width="32" height="32" loading="lazy" />
    </div>
    <div class="byob__item-body">
      <div class="byob__item-info">
        <div class="byob__item-image-title">
          <div class="byob__item-image mobile">
            <img src="${image}" alt="${productTitleText}" width="32" height="32" loading="lazy" />
          </div>
          <h3 class="byob__item-title">
            <span>${productTitleText}</span>
          </h3>
        </div>
        <div class="byob__item-variant">
          <span>Colour <strong>${displayColorTitle}</strong></span>
          <span>Size <strong>${sizeTitle}</strong></span>
        </div>
      </div>
      <div class="byob__item-price">
        <div class="byob__item-price_regular">${moneyFormatHandler(price)}</div>
      </div>
    </div>
    <button class="byob__item-remove" data-uniq-id="${uniqId}">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.84819 3.66902C4.09227 3.42494 4.43625 3.37319 4.61649 3.55344L12.4491 11.386C12.6293 11.5662 12.5776 11.9102 12.3335 12.1543C12.0894 12.3984 11.7454 12.4501 11.5652 12.2699L3.73261 4.43732C3.55236 4.25708 3.60411 3.9131 3.84819 3.66902Z" fill="#2F2F2F"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.66743 12.1542C3.42336 11.9102 3.37161 11.5662 3.55185 11.386L11.3844 3.55338C11.5647 3.37314 11.9086 3.42489 12.1527 3.66897C12.3968 3.91305 12.4485 4.25703 12.2683 4.43727L4.43573 12.2698C4.25549 12.4501 3.91151 12.3983 3.66743 12.1542Z" fill="#2F2F2F"/>
      </svg>
    </button>
  `

  byobBundleList.appendChild(bundleItem);
  bundleItemsHandler({ id, image, price, productTitle, colorTitle, sizeTitle, uniqId }, 'ADD', isLoadPage, isAjaxRender);
}

function addToCartHandler() {
  const itemMap = {};

  for (const item of addedBundleItems) {
    const id = item.id;
    if (itemMap[id]) {
      itemMap[id].quantity += 1;
    } else {
      itemMap[id] = {
        id: id,
        quantity: 1,
        properties: {
          _byob_property: document.querySelector('.byob__widget').getAttribute('data-mini-cart-tag')
        }
      };
    }
  }

  const formData = {
    items: Object.values(itemMap),
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      return response.json();
    })
    .then(() => {
      document.querySelectorAll('.byob__item-remove').forEach(byobClose => byobClose.click());
      if (document.querySelector('.byob__widget.is--open')) {
        document.querySelector('.byob__widget-toggle').click();
        // We use setTimeout to open the Cart after the animation for BYOBWidget is complete
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        }, 300);
      } else {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

//DWFT-4827 code goes here
function handleByobItemCount() {
  let byobData = localStorage.getItem('byob_items');

  if (byobData) {
    let byobItems = JSON.parse(byobData);
    let byobItemCount;

    if (Array.isArray(byobItems)) {
      byobItemCount = byobItems.length;
      progressbarMessageHandler(byobItemCount);
      progressBarHandler(byobItemCount);
    }
  }
}

function progressbarMessageHandler(itemCount) {
  const { byob_tier1_qty, byob_tier2_qty, byob_tier3_qty } = theme.settings;
  let count = itemCount;

  const messageContainer = document.querySelector('.byob-progressbar-message h3');

  function getTierMessage(count, tier1, tier2, tier3) {
    // checking out empty or undefined tiers
    const tiers = [tier1, tier2, tier3].filter(n => typeof n === 'number' && n > 0).sort((a, b) => a - b);

    if (count === 0 && tiers[0]) {
      let byob_empty_message_text = theme.settings.byob_empty_message_text;
      return byob_empty_message_text.replace(/<\/?p>/gi, '');
    }

    if (count < tiers[0]) {
      const nextTier = tiers[0];
      const x = nextTier - count;
      let byob_inprogress_msg = theme.settings.byob_inprogress_msg;
      byob_inprogress_msg = byob_inprogress_msg.replace("X", x);
      return byob_inprogress_msg.replace(/<\/?p>/gi, '');
    }

    if (count >= tiers[0] && count < (tiers[1] || Infinity)) {
      const nextTier = tiers[1];
      const x = nextTier - count;
      let byob_message_tier1_msg = theme.settings.byob_message_tier1_msg;
      const messageResult = tierMessageHandler(byob_message_tier1_msg);
      let tier_message_part1 = messageResult.tier_msg_part1.replace(/<\/?p>/gi, '');
      let tier_message_part2 = messageResult.tier_msg_part2.replace(/<\/?p>/gi, '');
      tier_message_part2 = tier_message_part2.replace("X", x);
      const styledPart1 = `<span class="tier-msg-partone">${tier_message_part1}</span>`;
      return styledPart1 + tier_message_part2;
    }

    if (tiers[1] && count >= tiers[1] && count < (tiers[2] || Infinity)) {
      const nextTier = tiers[2];
      const x = nextTier - count;
      let byob_message_tier2_msg = theme.settings.byob_message_tier2_msg;
      const messageResult = tierMessageHandler(byob_message_tier2_msg);
      let tier_message_part1 = messageResult.tier_msg_part1.replace(/<\/?p>/gi, '');
      let tier_message_part2 = messageResult.tier_msg_part2.replace(/<\/?p>/gi, '');
      tier_message_part2 = tier_message_part2.replace("X", x);
      const styledPart1 = `<span class="tier-msg-partone">${tier_message_part1}</span>`;
      return styledPart1 + tier_message_part2;
    }

    if (tiers[2] && count >= tiers[2]) {
      let byob_message_tier3_msg = theme.settings.byob_message_tier3_msg;
      const messageResult = tierMessageHandler(byob_message_tier3_msg);
      let tier_message_part1 = messageResult.tier_msg_part1.replace(/<\/?p>/gi, '');
      let tier_message_part2 = messageResult.tier_msg_part2.replace(/<\/?p>/gi, '');
      const styledPart1 = `<span class="tier-msg-partone">${tier_message_part1}</span>`;

      return styledPart1 + tier_message_part2;
    }

    return '';
  }

  const message = getTierMessage(count, byob_tier1_qty, byob_tier2_qty, byob_tier3_qty);

  if (messageContainer) {
    messageContainer.innerHTML = message;
  }
}

function progressBarHandler(itemCount) {
  const progressbarWrapper = document.getElementById('byob-bar-wrapper');
  progressbarWrapper.innerHTML = '';

  const {
    byob_tier1_qty,
    byob_tier2_qty,
    byob_tier3_qty,
    byob_tier1_discount,
    byob_tier2_discount,
    byob_tier3_discount
  } = theme.settings;

  const currentCount = itemCount;

  const barLength = Math.max(byob_tier1_qty, byob_tier2_qty, byob_tier3_qty);
  const tiers = [
    { qty: byob_tier1_qty, discount: byob_tier1_discount },
    { qty: byob_tier2_qty, discount: byob_tier2_discount },
    { qty: byob_tier3_qty, discount: byob_tier3_discount }
  ];

  for (let i = 1; i <= barLength; i++) {
    const barInnerWrap = document.createElement('div');
    barInnerWrap.className = 'byob-bar-inner-wrap';

    const percentageBar = document.createElement('div');
    percentageBar.className = 'percentage';

    const bar = document.createElement('div');
    bar.className = 'byob-bar';

    // Checking if it's tier bar
    const tier = tiers.find(t => t.qty === i);

    if (tier) {
      percentageBar.innerText = `${tier.discount}%`;

      if (i <= currentCount) {
        percentageBar.style.opacity = '1';
        bar.style.opacity = '1';
      } else {
        percentageBar.style.opacity = '0.3';
        bar.style.opacity = '0.3';
      }

      if (isTenaStore) {
        bar.style.background = '#003A81';
      } else {
        bar.style.background = '#d11788';
      }
    } else {
      percentageBar.innerHTML = '&nbsp;';

      if (i <= currentCount) {
        if (isTenaStore) {
          bar.style.backgroundColor = '#439EDD';
        } else {
          bar.style.backgroundColor = '#2e2e2e';
        }
        bar.style.opacity = '1';
      } else {
        if (isTenaStore) {
          bar.style.backgroundColor = '#D8D8D8';
        } else {
          bar.style.backgroundColor = '#d7d3d3';
        }
      }
    }

    barInnerWrap.appendChild(percentageBar);
    barInnerWrap.appendChild(bar);
    progressbarWrapper.appendChild(barInnerWrap);
  }
}

function tierMessageHandler(tierMessage) {
  let tier_msg_split = tierMessage.split("%");
  let tier_before_percent = tier_msg_split[0];

  let tier_after_percent = tierMessage
    .replace(tier_before_percent, '')
    .replace('%', '');

  let tier_space_split = tier_after_percent.trim().split(" ");
  let tier_first_word = tier_space_split[0]; // "Only"

  // first part of the message
  let tier_msg_part1 = tier_before_percent + "%" + tier_first_word + " ";

  // second part of the message
  let tier_msg_part2 = tierMessage.replace(tier_msg_part1, '');

  return {
    tier_msg_part1: tier_msg_part1,
    tier_msg_part2: tier_msg_part2
  };
}

// script for on select change in variant-popup for BYOB 
window.byobDebugEnabled = window.byobDebugEnabled || false;
window.byobDebugLog = function (...args) {
  if (!window.byobDebugEnabled) return;
  try { console.warn(...args); } catch (e) { /* ignore */ }
};

window.attachEventListeners2 = function (context = document) {
  const productCards = context.querySelectorAll('.product-card');

  productCards.forEach(card => {
    const productId = card.dataset.productCardId; // Get the product ID from the product card
    if (!productId) {
      window.byobDebugLog('Product card missing data-product-card-id:', card);
      return; // Skip if no product ID
    }
    const variantSelector = card.querySelector('.variant-selector');
    const colorOptions = card.querySelector('.color-options');
    const sizeOptions = card.querySelector('.size-options');

    // Find the corresponding Add to Bundle button and its proxy
    const byobBtn = context.querySelector(`.byobbtn[data-byob-product-id="${productId}"]`);
    const byobBtnProxy = context.querySelector(`.proxy-byob-button[data-byob-proxy-product-id="${productId}"]`);

    // Ensure essential elements exist for this card
    if (!variantSelector || !colorOptions || !sizeOptions || !byobBtn || !byobBtnProxy) {
      window.byobDebugLog(`Missing essential elements for product card ID ${productId}. Skipping event listeners.`, card);
      return;
    }

    const activecolorOptions = colorOptions.querySelector('label.variant__button-label');
    const activecolorPopuplabel = variantSelector.querySelector('.active-color');
    const variantPopupTitle = card.querySelector('.variant-title-popup.disabled');
    const variantPopupTitleDisabled = card.querySelector('.variant-title-popup.notdisabled');

    // Find the corresponding activeSizeInfoStrong and activeColorInfoStrong elements
    const activeSizeInfoStrong = context.querySelector(`.active-size-info[data-product-id="${productId}"] strong`);
    const activeSizeInfoStrongDesk = context.querySelector(`.active-size-info.desktop[data-product-id="${productId}"] strong`);
      // Ensure initial active size is set from any available data-variant-title
      try {
        if (typeof window.byobSetActiveSizeFromVariantTitle === 'function') {
          window.byobSetActiveSizeFromVariantTitle(productId);
        }
      } catch (e) {
        window.byobDebugLog('byobSetActiveSizeFromVariantTitle call failed', e);
      }
    // Muted-text elements that show the size range (desktop and other)
    const activeSizeRange = context.querySelector(`.active-size-info[data-product-id="${productId}"] .muted-text`);
    const activeSizeRangeDesk = context.querySelector(`.active-size-info.desktop[data-product-id="${productId}"] .muted-text`);
    const activeColorInfoStrong = context.querySelector(`.active-color-info[data-product-id="${productId}"] strong`);
    const activeColorInfoStrongMob = context.querySelector(`.active-color-wrapper.on-mobile  .active-color-info[data-product-id="${productId}"] strong`);
    const colorCircle = context.querySelector(`.active-color-info[data-product-id="${productId}"] .color-circle`);
    const colorCircleMob = context.querySelector(`.active-color-wrapper.on-mobile .active-color-info[data-product-id="${productId}"] .color-circle`);

    // Find the price element for this specific product card
    const popup = context.querySelector(`#variant-popup-${productId}`);
    const priceElement = context.querySelector(`.grid-product__price[data-product-id="${productId}"] .grid-product__price--after`);

    const screenWidth = window.innerWidth;
    const allProductVariantsData = window.productVariantsData || {};
    const productVariants = allProductVariantsData[productId] || allProductVariantsData[String(productId)] || [];
    let selectedColor = '';
    let selectedSize = '';

    // Function to update size options based on selected color
    function updateSizeOptions(controlElement) {
      const color = controlElement.value;

      // Reset disabled state for all sizes
      sizeOptions.querySelectorAll('.variant-item').forEach(item => {
        const sizelabel = item.querySelector('.variant__button-label');
        const sizeInput = item.querySelector('input');
        sizelabel.classList.remove('disabled');
        sizeInput.disabled = false; // Ensure input is enabled by default
      });

      // Reset visual indicators
      if (activecolorOptions) activecolorOptions.classList.remove('disabled');
      if (colorCircle) colorCircle.classList.remove('disabled');
      if (colorCircleMob) colorCircleMob.classList.remove('disabled');
      if (screenWidth <= 768) {
        if (variantPopupTitle) variantPopupTitle.style.display = 'none';
        if (variantPopupTitleDisabled) variantPopupTitleDisabled.style.display = 'none';
      }
      if (activecolorPopuplabel) activecolorPopuplabel.style.textDecoration = 'none';
      if (activeSizeInfoStrongDesk) activeSizeInfoStrongDesk.style.textDecoration = 'none';
      if (activeSizeInfoStrong) activeSizeInfoStrong.style.textDecoration = 'none';
      if (activeColorInfoStrong) activeColorInfoStrong.style.textDecoration = 'none';
      if (activeColorInfoStrongMob) activeColorInfoStrongMob.style.textDecoration = 'none';

      selectedSize = ''; // Reset selected size
      clearButtonData(); // Clear button data attributes
      // Update active color display
      updateActiveColorDisplay(controlElement);

      if (color && productVariants.length) {
        const availableSizes = [];
          // availableSizes: sizes that are purchasable (variant.available === true)
          // sizesForRange: sizes that exist for this color (include OOS), used for displaying the size range
          const sizesForRange = [];
          productVariants.forEach(variant => {
            if (variant.option1 === color) {
              // push to sizesForRange regardless of availability
              if (!sizesForRange.includes(variant.option2)) sizesForRange.push(variant.option2);
              // push to availableSizes only if variant is available
              if (variant.available && !availableSizes.includes(variant.option2)) {
                availableSizes.push(variant.option2);
              }
            }
          });
        // Gather all sizes in the DOM order to preserve product option ordering
        const allSizesInDomOrder = [];
        sizeOptions.querySelectorAll('.variant-item input').forEach(input => {
          const val = input.value;
          if (!allSizesInDomOrder.includes(val)) allSizesInDomOrder.push(val);
        });
        // Iterate through all size options: hide those not present for this color (deleted),
        // and visually mark those that exist but are OOS. IMPORTANT: keep the radio inputs
        // enabled so users can still select OOS sizes.
        sizeOptions.querySelectorAll('.variant-item').forEach(item => {
          const size = item.querySelector('input').value;
          const sizelabel = item.querySelector('.variant__button-label');
          const sizeInput = item.querySelector('input');
          if (!sizesForRange.includes(size)) {
            // Hide size completely when it's deleted for this color
            item.style.display = 'none';
          } else {
            // Ensure it's visible
            item.style.display = '';
            // Toggle disabled visual if not available but DO NOT disable the input
            if (!availableSizes.includes(size)) {
              // preserve visual disabled state on the label
              sizelabel.classList.add('disabled');
              // allow selection even if OOS
              sizeInput.disabled = false;
            } else {
              sizelabel.classList.remove('disabled');
              sizeInput.disabled = false;
            }
          }
        });

        // Apply disabled visual states if no sizes are available for the selected color
        if (availableSizes.length === 0) {
          if (activecolorOptions) activecolorOptions.classList.add('disabled');
          if (screenWidth <= 768) {
            if (variantPopupTitle) variantPopupTitle.style.display = 'block';
            if (variantPopupTitleDisabled) variantPopupTitleDisabled.style.display = 'none';
          }
          if (colorCircle) colorCircle.classList.add('disabled');
          if (colorCircleMob) colorCircleMob.classList.add('disabled');
          if (activecolorPopuplabel) activecolorPopuplabel.style.textDecoration = 'line-through';
          if (activeSizeInfoStrongDesk) activeSizeInfoStrongDesk.style.textDecoration = 'line-through';
          if (activeSizeInfoStrong) activeSizeInfoStrong.style.textDecoration = 'line-through';
          if (activeColorInfoStrong) activeColorInfoStrong.style.textDecoration = 'line-through';
          if (activeColorInfoStrongMob) activeColorInfoStrongMob.style.textDecoration = 'line-through';
        }
        // Select the first available size that is currently checked, or the first available if none checked
        const currentCheckedSize = sizeOptions.querySelector('input[type="radio"]:checked');
        if (currentCheckedSize && availableSizes.includes(currentCheckedSize.value)) {
          selectedSize = currentCheckedSize.value;
          updateButtonData(color, selectedSize);
          updateActiveSizeDisplay(selectedSize);
        } else if (availableSizes.length > 0) {
          // If the previously selected size is not available, try to select the first available
          const firstAvailableSizeInput = sizeOptions.querySelector(`input[value="${availableSizes[0]}"]`);
          if (firstAvailableSizeInput) {
            firstAvailableSizeInput.checked = true; // Programmatically check it
            selectedSize = firstAvailableSizeInput.value;
            updateButtonData(color, selectedSize);
            updateActiveSizeDisplay(selectedSize);
          } else {
            clearButtonData();
            updateActiveSizeDisplay('');
          }
        } else {
          // No sizes available for this color
          clearButtonData();
          updateActiveSizeDisplay('');
        }

        // Update the visible size-range display using sizes that exist for this color (including OOS)
        updateSizeRangeDisplay(allSizesInDomOrder, sizesForRange);
      } else {
        // No color selected or productVariants data missing
        clearButtonData();
        updateActiveSizeDisplay('');
        // When no color selected, show size range across all variants (include OOS but skip deleted)
        const allSizesInDomOrder = [];
        sizeOptions.querySelectorAll('.variant-item input').forEach(input => {
          const val = input.value;
          if (!allSizesInDomOrder.includes(val)) allSizesInDomOrder.push(val);
        });
        const sizesForRangeAll = [];
        if (productVariants.length) {
          productVariants.forEach(variant => {
            if (variant && variant.options && variant.options[1]) {
              const s = variant.options[1];
              if (!sizesForRangeAll.includes(s)) sizesForRangeAll.push(s);
            }
          });
        }
        updateSizeRangeDisplay(allSizesInDomOrder, sizesForRangeAll);
      }
    }

    // Update the size range text content. `allSizes` should be an array in product option order.
    function updateSizeRangeDisplay(allSizes, availableSizes) {
      if (!activeSizeRange && !activeSizeRangeDesk) return;

      const orderedAvailable = [];
      if (Array.isArray(allSizes) && allSizes.length) {
        allSizes.forEach(s => {
          if (availableSizes.includes(s) && !orderedAvailable.includes(s)) orderedAvailable.push(s);
        });
      } else {
        // Fallback: derive ordering from availableSizes itself
        availableSizes.forEach(s => { if (!orderedAvailable.includes(s)) orderedAvailable.push(s); });
      }

      let rangeText = '';
      if (orderedAvailable.length > 1) {
        rangeText = `${orderedAvailable[0]}–${orderedAvailable[orderedAvailable.length - 1]}`;
      } else if (orderedAvailable.length === 1) {
        rangeText = orderedAvailable[0];
      }

      if (activeSizeRange) activeSizeRange.textContent = rangeText;
      if (activeSizeRangeDesk) activeSizeRangeDesk.textContent = rangeText;
    }
    // Function to update the active color display
    function updateActiveColorDisplay(controlElement) {
      const color = controlElement.value;
      const activeColorNameSpans = card.querySelectorAll('.byob-active-color-name .active-color');

      activeColorNameSpans.forEach(span => {
        span.textContent = color;
      });

      if (activeColorInfoStrong) {
        activeColorInfoStrong.textContent = color;
      }

      if (activeColorInfoStrongMob) {
        activeColorInfoStrongMob.textContent = color;
      }
      if (colorCircle && controlElement && controlElement.nextElementSibling) {
        colorCircle.removeAttribute('style');

        // Get source inline styles from the label (next sibling of the radio input)
        const sourceStyles = controlElement.nextElementSibling.style;

        // Apply each inline style property to colorCircle
        for (let i = 0; i < sourceStyles.length; i++) {
          const propName = sourceStyles[i];
          colorCircle.style[propName] = sourceStyles.getPropertyValue(propName);
        }
      }
      if (colorCircleMob && controlElement && controlElement.nextElementSibling) {
        colorCircleMob.removeAttribute('style');

        // Get source inline styles from the label (next sibling of the radio input)
        const sourceStyles = controlElement.nextElementSibling.style;

        // Apply each inline style property to colorCircleMob
        for (let i = 0; i < sourceStyles.length; i++) {
          const propName = sourceStyles[i];
          colorCircleMob.style[propName] = sourceStyles.getPropertyValue(propName);
        }
      }
    }

    // Function to update the active size display
    function updateActiveSizeDisplay(size) {
      if (activeSizeInfoStrong) {
        activeSizeInfoStrong.textContent = size;
      }
      if (activeSizeInfoStrongDesk) { // Check for desktop version too
        activeSizeInfoStrongDesk.textContent = size;
      }
    }

    // Function to find the matching variant and update data attributes
    function updateButtonData(color, size) {
      let foundVariant = null;
      let isAvailable = false;

      if (!productVariants.length) {
        clearButtonData();
        return;
      }

      productVariants.forEach(variant => {
        if (variant.option1 === color && variant.option2 === size) {
          foundVariant = variant;
          isAvailable = variant.available;
          return; // Exit the loop once a match is found
        }
      });

      if (foundVariant && isAvailable) {
        byobBtn.dataset.variantId = foundVariant.id;
        byobBtn.dataset.price = foundVariant.price;
        byobBtn.dataset.colorName = color;
        byobBtn.dataset.sizeName = size;
        byobBtn.dataset.variantImage = foundVariant.featured_image?.src || ''; // Use optional chaining for image src
        try {
          window.byobSyncColorSwatchStyle(productId, color);
        } catch (e) {
          window.byobDebugLog('byobSyncColorSwatchStyle failed', e);
        }
        try {
          window.byobSlideGridToMatchingColor(productId, color, byobBtn.dataset.variantImage);
        } catch (e) {
          window.byobDebugLog('byobSlideGridToMatchingColor failed', e);
        }
        productUrlHandler(true, foundVariant.id);

        byobBtn.classList.remove('disabled');
        byobBtn.disabled = false;
        byobBtnProxy.classList.remove('disabled');
        byobBtnProxy.disabled = false;

        let activecolorOptionsOld = colorOptions.querySelector('label.variant__button-label.disabled');
        activecolorOptionsOld && activecolorOptionsOld.classList.remove('disabled');
        // Visual feedback for active/available state
        if (activecolorOptions) activecolorOptions.classList.remove('disabled');
        if (colorCircle) colorCircle.classList.remove('disabled');
        if (colorCircleMob) colorCircleMob.classList.remove('disabled');
        if (activecolorPopuplabel) activecolorPopuplabel.style.textDecoration = 'none';
        if (screenWidth <= 768) {
          if (variantPopupTitle) variantPopupTitle.style.display = 'none';
          if (variantPopupTitleDisabled) variantPopupTitleDisabled.style.display = 'block';
        }
        if (activeSizeInfoStrongDesk) activeSizeInfoStrongDesk.style.textDecoration = 'none';
        if (activeSizeInfoStrong) activeSizeInfoStrong.style.textDecoration = 'none';
        if (activeColorInfoStrong) activeColorInfoStrong.style.textDecoration = 'none';
        if (activeColorInfoStrongMob) activeColorInfoStrongMob.style.textDecoration = 'none';
        // --- PRICE UPDATE LOGIC ---
        if (priceElement) {
             priceElement.innerHTML = theme.Currency.formatMoney(foundVariant.price, theme.settings.moneyFormat);
        }
        // --- END PRICE UPDATE LOGIC ---

      } else {
        // No matching variant found or variant is OOS
        clearButtonData();

        if (foundVariant && foundVariant.id) {
          productUrlHandler(true, foundVariant.id);
        } else {
          productUrlHandler(false);
        }

        let activecolorOptionsOld = colorOptions.querySelector('label.variant__button-label.disabled');
        activecolorOptionsOld && activecolorOptionsOld.classList.remove('disabled');
        let newActiveColorOptions = colorOptions.querySelector('input:checked + label.variant__button-label')

        // Visual feedback for disabled/unavailable state
        if (activeSizeInfoStrongDesk) activeSizeInfoStrongDesk.style.textDecoration = 'line-through';
        if (activeSizeInfoStrong) activeSizeInfoStrong.style.textDecoration = 'line-through';
        if (activeColorInfoStrong) activeColorInfoStrong.style.textDecoration = 'line-through';
        if (activeColorInfoStrongMob) activeColorInfoStrongMob.style.textDecoration = 'line-through';
        if (newActiveColorOptions) newActiveColorOptions.classList.add('disabled');
        if (screenWidth <= 768) {
          if (variantPopupTitle) variantPopupTitle.style.display = 'block';
          if (variantPopupTitleDisabled) variantPopupTitleDisabled.style.display = 'none';
        }
        if (colorCircle) colorCircle.classList.add('disabled');
        if (colorCircleMob) colorCircleMob.classList.add('disabled');
        if (activecolorPopuplabel) activecolorPopuplabel.style.textDecoration = 'line-through';
      }
    }

    // Function to clear the button's data attributes and disable it
    function clearButtonData() {
      byobBtn.dataset.variantId = '';
      byobBtn.dataset.price = '';
      byobBtn.dataset.colorName = '';
      byobBtn.dataset.sizeName = '';
      byobBtn.dataset.variantImage = '';
      byobBtn.classList.add('disabled');
      byobBtn.disabled = true;
      byobBtnProxy.classList.add('disabled');
      byobBtnProxy.disabled = true;
    }

    function productUrlHandler(isVariant, variantId) {
      const mainProductCard = card.closest('.grid__item.grid-product');
      if (mainProductCard) {
        const productLinks = mainProductCard.querySelectorAll('.byob-link');
        productLinks.forEach(link => {
          const rawUrl = link.dataset.productUrl || link.getAttribute('href') || '';
          if (!rawUrl) return;

          // Normalize malformed query strings (extra '?') and replace only the variant param.
          const firstQueryIndex = rawUrl.indexOf('?');
          const basePath = firstQueryIndex === -1 ? rawUrl : rawUrl.slice(0, firstQueryIndex);
          const rawQuery = firstQueryIndex === -1 ? '' : rawUrl.slice(firstQueryIndex + 1).replace(/\?/g, '&');

          const params = new URLSearchParams(rawQuery);
          params.delete('variant');

          if (isVariant && variantId) {
            params.set('variant', String(variantId));
            params.set('byob', '1');
          } else {
            params.delete('byob');
          }

          const nextQuery = params.toString();
          const nextHref = nextQuery ? `${basePath}?${nextQuery}` : basePath;
          link.setAttribute('href', nextHref);
          link.dataset.productUrl = nextHref;
        });
      }
    }

    // --- Event Listeners ---
    // Remove existing listeners to prevent duplicates if attachEventListeners2 is called multiple times
    // (e.g., due to AJAX pagination)
    colorOptions.removeEventListener('change', colorChangeHandler);
    sizeOptions.removeEventListener('change', sizeChangeHandler);
    byobBtn.removeEventListener('click', byobClickHandler);

    // Add new listeners
    colorOptions.addEventListener('change', colorChangeHandler);
    sizeOptions.addEventListener('change', sizeChangeHandler);
    byobBtn.addEventListener('click', byobClickHandler);

    function colorChangeHandler(event) {
      if (event.target.classList.contains('color-radio')) {
        selectedColor = event.target.value;
        window.byobSetPersistedUserSelection(productId, { color: selectedColor, size: selectedSize });
        updateSizeOptions(event.target);
      }
    }

    function sizeChangeHandler(event) {
      if (event.target.classList.contains('size-radio')) {
        selectedSize = event.target.value;
        window.byobSetPersistedUserSelection(productId, { color: selectedColor, size: selectedSize });
        const label = popup.querySelector(`label[for="${event.target.id}"]`);
        const displaySize = label ? label.textContent.trim() : selectedSize;
        if (selectedColor && selectedSize) {
          updateButtonData(selectedColor, selectedSize);
          updateActiveSizeDisplay(displaySize);
        } else {
          clearButtonData();
          updateActiveSizeDisplay('');
        }
      }
    }

    function byobClickHandler(event) {
      if (this.classList.contains('disabled')) {
        event.preventDefault();
        event.stopImmediatePropagation(); // Prevent other click handlers from running
        return;
      }
      // Your add to cart logic here (if you have any)
      // This button will now have the correct variant ID, price, etc. in its data attributes
    }

    // --- Initialization ---
    // Initialize button state based on currently selected (checked) radios
    const initialColorRadio = colorOptions.querySelector('.color-radio:checked');
    if (initialColorRadio) {
      selectedColor = initialColorRadio.value;
      updateSizeOptions(initialColorRadio); // This will also trigger size selection and button data update
    } else {
      clearButtonData(); // No initial color selected, disable button
    }
  });
};

// --- DOMContentLoaded Listener ---
// This ensures the function runs once the DOM is fully loaded.
// If your theme uses AJAX for pagination, you'll need to re-call
// window.attachEventListeners2() after new product cards are loaded.
window.byobRunPostRenderSync = function (context = document) {
  try { if (typeof window.byobApplySizeFromVariantTitles === 'function') window.byobApplySizeFromVariantTitles(); } catch (e) { /* ignore */ }
  try { if (typeof window.byobPrepopulateButtons === 'function') window.byobPrepopulateButtons(context); } catch (e) { /* ignore */ }
  try { if (typeof window.byobSyncAllColorSwatches === 'function') window.byobSyncAllColorSwatches(context); } catch (e) { /* ignore */ }
  try { if (typeof window.byobSyncAllGridSlides === 'function') window.byobSyncAllGridSlides(context); } catch (e) { /* ignore */ }
};

window.byobScheduleInitialHydration = function () {
  let attempts = 0;
  const maxAttempts = 20;
  const delayMs = 250;

  const tick = () => {
    attempts += 1;
    try { if (typeof window.byobRunPostRenderSync === 'function') window.byobRunPostRenderSync(document); } catch (e) { /* ignore */ }

    const hasVariantData = !!window.productVariantsData && Object.keys(window.productVariantsData).length > 0;
    if (hasVariantData || attempts >= maxAttempts) return;
    setTimeout(tick, delayMs);
  };

  setTimeout(tick, 80);
};

document.addEventListener('DOMContentLoaded', function () {
  window.attachEventListeners2();
  try { if (typeof window.byobScheduleInitialHydration === 'function') window.byobScheduleInitialHydration(); } catch (e) { /* ignore */ }
});

// Also re-apply after the full window load to cover late asset initialization
window.addEventListener('load', function () {
  try {
    setTimeout(() => {
      if (typeof window.byobRunPostRenderSync === 'function') {
        window.byobRunPostRenderSync(document);
      }
    }, 150);
  } catch (e) {}
});

// Explicit hook for async collection variant data completion.
window.addEventListener('byob:variants-ready', function () {
  try {
    if (typeof window.byobRunPostRenderSync === 'function') {
      window.byobRunPostRenderSync(document);
    }
  } catch (e) {
    /* ignore */
  }
});

// Helper: extract size part from a variant title string like "Color / Size"

// Keep BYOB product links in sync at click-time so title click and href behave identically.
document.addEventListener('click', function (event) {
  const link = event.target.closest && event.target.closest('a.byob-link');
  if (!link) return;

  const gridItem = link.closest && link.closest('.grid__item.grid-product');
  if (!gridItem) return;

  const byobBtn = gridItem.querySelector('.byobbtn[data-byob-product-id]');
  if (!byobBtn) return;

  const variantId = byobBtn.dataset.variantId;
  if (!variantId) return;

  const rawUrl = link.dataset.productUrl || link.getAttribute('href') || '';
  if (!rawUrl) return;

  const firstQueryIndex = rawUrl.indexOf('?');
  const basePath = firstQueryIndex === -1 ? rawUrl : rawUrl.slice(0, firstQueryIndex);
  const rawQuery = firstQueryIndex === -1 ? '' : rawUrl.slice(firstQueryIndex + 1).replace(/\?/g, '&');
  const params = new URLSearchParams(rawQuery);

  params.delete('variant');
  params.set('variant', String(variantId));
  params.set('byob', '1');

  const nextQuery = params.toString();
  const nextHref = nextQuery ? `${basePath}?${nextQuery}` : basePath;

  link.setAttribute('href', nextHref);
  link.dataset.productUrl = nextHref;
});
window._byobExtractSizeFromVariantTitle = function (rawVariantTitle) {
  if (!rawVariantTitle) return '';
  const variantTitle = String(rawVariantTitle || '').trim();
  if (!variantTitle) return '';
  let parts = variantTitle.split('/').map(p => p.trim()).filter(Boolean);
  if (parts.length <= 1) {
    parts = variantTitle.split('-').map(p => p.trim()).filter(Boolean);
  }
  // Build sensible candidates for size matching:
  // - If there are more than 2 parts (e.g., "Color / 15–16Y / 170cm"), prefer the joined size part "15–16Y / 170cm"
  // - Fallback to the second part or the last part
  if (parts.length > 2) {
    const combined = parts.slice(1).join(' / ');
    return combined.trim();
  }
  const sizePart = parts.length > 1 ? parts[1] : (parts[parts.length - 1] || '');
  return sizePart ? sizePart.trim() : '';
};

// Apply size extracted from `data-variant-title` to all `.active-size-info.desktop ... strong` on the page
window.byobApplySizeFromVariantTitles = function () {
  try {
    // Update both size and color strong elements from `data-variant-title` (format: "Color / Size")
    const sizeElems = document.querySelectorAll('.active-size-info.desktop[data-product-id] strong, .active-size-info[data-product-id] strong');
    sizeElems.forEach(strong => {
      const parent = strong.closest('.active-size-info');
      if (!parent) return;
      const pid = parent.getAttribute('data-product-id');
      if (!pid) return;

      const gridItem = document.querySelector(`.grid__item[data-byob-product-id="${pid}"]`) || document.querySelector(`.grid__item[data-product-id="${pid}"]`);
      const source = (gridItem && (gridItem.querySelector('a.grid-product__link') || gridItem.querySelector('.byobbtn'))) || document.querySelector(`a.grid-product__link[data-product-id="${pid}"]`) || document.querySelector(`.byobbtn[data-byob-product-id="${pid}"]`);

      const raw = (source && (source.getAttribute('data-variant-title') || (source.dataset && source.dataset.variantTitle))) || '';
      const parts = window._byobExtractPartsFromVariantTitle ? window._byobExtractPartsFromVariantTitle(raw) : (raw ? raw.split('/').map(p=>p.trim()) : []);
      const color = parts[0] || '';
      // Build size candidate preferences: combined slice(1..) if multiple parts, then parts[1], then last part
      let size = '';
      if (parts.length > 2) {
        size = parts.slice(1).join(' / ');
      } else if (parts[1]) {
        size = parts[1];
      } else {
        size = parts[parts.length - 1] || '';
      }
      if (size) {
        strong.textContent = size;
        // enforce briefly in case other init code overwrites it
        try { window._byobEnforceStrongValue(strong, size); } catch (e) {}
      }

      // Also update color strongs for the card if present
      if (color) {
        const colorStrong = document.querySelector(`.active-color-info[data-product-id="${pid}"] strong`);
        const colorStrongMob = document.querySelector(`.active-color-wrapper.on-mobile .active-color-info[data-product-id="${pid}"] strong`);
        if (colorStrong) {
          colorStrong.textContent = color;
          try { window._byobEnforceStrongValue(colorStrong, color); } catch (e) {}
        }
        if (colorStrongMob) {
          colorStrongMob.textContent = color;
          try { window._byobEnforceStrongValue(colorStrongMob, color); } catch (e) {}
        }
      }
    });
  } catch (e) {
    window.byobDebugLog('byobApplySizeFromVariantTitles failed', e);
  }
};

// Extract parts (color, size, ...) from a variant title string
window._byobExtractPartsFromVariantTitle = function (rawVariantTitle) {
  if (!rawVariantTitle) return [];
  const vt = String(rawVariantTitle).trim();
  if (!vt) return [];
  let parts = vt.split('/').map(p => p.trim()).filter(Boolean);
  if (parts.length <= 1) parts = vt.split('-').map(p => p.trim()).filter(Boolean);
  return parts;
};

// Enforcement: observe a <strong> and restore `expectedValue` if it's overwritten for a short period
window._byobEnforceStrongValue = (function () {
  const observers = new WeakMap();

  return function (strongElem, expectedValue, opts = {}) {
    if (!strongElem || !expectedValue) return;
    // If already enforced for this element, skip
    if (observers.has(strongElem)) return;

    const maxDuration = opts.maxDuration || 1500; // ms
    const maxAttempts = opts.maxAttempts || 8;
    let attempts = 0;

    const restore = () => {
      try {
        if (strongElem.textContent !== expectedValue) {
          strongElem.textContent = expectedValue;
        }
      } catch (e) {}
    };

    // Initial restore
    restore();

    const mo = new MutationObserver(mutations => {
      for (const m of mutations) {
        // If any change to text content or children, restore
        if (m.type === 'characterData' || m.type === 'childList' || m.type === 'subtree') {
          attempts++;
          restore();
          if (attempts >= maxAttempts) {
            try { mo.disconnect(); } catch (e) {}
            observers.delete(strongElem);
            return;
          }
        }
      }
    });

    // Observe text changes within strongElem
    try {
      mo.observe(strongElem, { characterData: true, childList: true, subtree: true });
      observers.set(strongElem, mo);
    } catch (e) {
      // If observe fails, fallback to interval restore
      const interval = setInterval(() => {
        attempts++;
        restore();
        if (attempts >= maxAttempts) {
          clearInterval(interval);
        }
      }, Math.max(100, Math.floor(maxDuration / maxAttempts)));
      // don't store interval in WeakMap
    }

    // Ensure we stop observing after maxDuration
    setTimeout(() => {
      try { const o = observers.get(strongElem); if (o) o.disconnect(); } catch (e) {}
      observers.delete(strongElem);
    }, maxDuration + 50);
  };
})();

// Run once on DOMContentLoaded to populate desktop strong elements
document.addEventListener('DOMContentLoaded', function () {
  try { window.byobApplySizeFromVariantTitles(); } catch (e) { /* ignore */ }
});

// Re-run when browser history navigation changes (URL filters)
window.addEventListener('popstate', function () {
  try { window.byobApplySizeFromVariantTitles(); } catch (e) { /* ignore */ }
});

// Observe DOM changes (AJAX filter results) and re-apply parsed sizes/colors when product cards change
(function () {
  let debounceTimeout = null;
  const observerCallback = function (mutationsList) {
    let changed = false;
    for (const m of mutationsList) {
      if (m.addedNodes && m.addedNodes.length) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && (n.matches && n.matches('.grid__item') || n.querySelector && n.querySelector('.grid__item'))) {
            changed = true; break;
          }
        }
      }
      if (changed) break;
    }
    if (changed) {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        try { window.byobApplySizeFromVariantTitles(); } catch (e) { /* ignore */ }
        try { window.byobPrepopulateButtons(); } catch (e) { /* ignore */ }
        try { window.byobSyncAllColorSwatches(document); } catch (e) { /* ignore */ }
        try { window.byobSyncAllGridSlides(document); } catch (e) { /* ignore */ }
      }, 120);
    }
  };

  const target = document.querySelector('#CollectionAjaxResult') || document.querySelector('.collection__grid') || document.body;
  try {
    const mo = new MutationObserver(observerCallback);
    mo.observe(target, { childList: true, subtree: true });
  } catch (e) {
    // MutationObserver not supported or target missing — no-op
  }
})();

// Delegate clicks on variant triggers to ensure popup pre-selection runs when user opens a card
document.addEventListener('click', function (e) {
  const trigger = e.target.closest && e.target.closest('.variant-trigger');
  if (!trigger) return;
  const card = trigger.closest && trigger.closest('.active-variant-row, .grid__item');
  const pid = card ? (card.getAttribute('data-product-id') || card.getAttribute('data-byob-product-id') || card.dataset.productCardId) : null;
  if (!pid) return;

  const syncCardVisuals = function (productId) {
    try {
      const btn = document.querySelector(`.byobbtn[data-byob-product-id="${productId}"]`);
      if (!btn) return;
      if (typeof window.byobSyncColorSwatchStyle === 'function') {
        window.byobSyncColorSwatchStyle(productId, btn.dataset.colorName || '');
      }
      if (typeof window.byobSlideGridToMatchingColor === 'function') {
        window.byobSlideGridToMatchingColor(productId, btn.dataset.colorName || '', btn.dataset.variantImage || '');
      }
    } catch (e) {
      /* ignore */
    }
  };

  // run after UI show animations
  setTimeout(() => {
    try { if (typeof window.byobAutoSelectFromVariantTitle === 'function') window.byobAutoSelectFromVariantTitle(pid); } catch (e) {}
    syncCardVisuals(pid);
    setTimeout(() => {
      syncCardVisuals(pid);
    }, 120);
  }, 60);
});

// Centralized BYOB helpers for auto-select and UI updates
window.byobUpdateCardSizeDisplay = function (productId, displaySize) {
  if (!productId || !displaySize) return;
  try {
    const desktopStrong = document.querySelector(`.active-size-info.desktop[data-product-id="${productId}"] strong`);
    const popupStrong = document.querySelector(`.active-size-info[data-product-id="${productId}"] strong`);
    if (desktopStrong) desktopStrong.textContent = displaySize;
    if (popupStrong) popupStrong.textContent = displaySize;
  } catch (e) {
    window.byobDebugLog('byobUpdateCardSizeDisplay failed', e);
  }
};

window.byobSlideGridToMatchingColor = function (productId, colorName, variantImageSrc) {
  if (!productId) return;

  const normalize = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\.[a-z0-9]+$/i, '')
    .replace(/[–—]/g, '-')
    .replace(/[_/]+/g, '-')
    .replace(/\s+/g, ' ')
    .replace(/\s*-\s*/g, '-')
    .replace(/[^a-z0-9\- ]/g, '')
    .trim();

  const card = document.querySelector(`.grid__item[data-byob-product-id="${productId}"], .grid__item[data-product-id="${productId}"]`);
  if (!card) return;

  const swiperContainer = card.querySelector(`.product-grid-swiper-${productId}`);
  if (!swiperContainer) return;

  let swiper = swiperContainer.swiper;
  if (!swiper && typeof Swiper !== 'undefined') {
    swiper = new Swiper(swiperContainer, {
      pagination: { el: swiperContainer.querySelector('.swiper-pagination'), clickable: true },
      navigation: {
        nextEl: swiperContainer.querySelector('.swiper-button-next'),
        prevEl: swiperContainer.querySelector('.swiper-button-prev'),
      },
      slidesPerView: 1,
    });
  }
  if (!swiper) return;

  const candidates = new Set();
  const normalizedColor = normalize(colorName);
  if (normalizedColor) {
    candidates.add(normalizedColor);
    candidates.add(normalizedColor.replace(/\s+/g, '-'));
    candidates.add(normalizedColor.replace(/\s+/g, ''));
  }

  if (variantImageSrc) {
    const img = String(variantImageSrc).toLowerCase();
    candidates.add(img);
    const parts = img.split('/');
    const file = parts[parts.length - 1] || '';
    const noQuery = file.split('?')[0] || file;
    const stem = noQuery.replace(/\.[a-z0-9]+$/i, '');
    const normalizedStem = normalize(stem);
    if (normalizedStem) {
      candidates.add(normalizedStem);
      candidates.add(normalizedStem.replace(/\s+/g, '-'));
      candidates.add(normalizedStem.replace(/\s+/g, ''));
    }
  }

  const allCandidates = Array.from(candidates).filter(Boolean);
  if (!allCandidates.length) return;

  const slides = swiperContainer.querySelectorAll('.swiper-slide');
  for (let i = 0; i < slides.length; i++) {
    const imgTag = slides[i].querySelector('img.grid-product__image');
    if (!imgTag) continue;
    const src = String(imgTag.getAttribute('src') || '').toLowerCase();
    const alt = String(imgTag.getAttribute('alt') || '').toLowerCase();
    const srcNoQuery = src.split('?')[0];
    const imageText = `${src} ${srcNoQuery} ${alt} ${normalize(alt)} ${normalize(srcNoQuery)}`;
    if (allCandidates.some(candidate => imageText.includes(candidate))) {
      swiper.slideTo(i);
      break;
    }
  }
};

window.byobSyncColorSwatchStyle = function (productId, colorName) {
  if (!productId || !colorName) return;

  const norm = (v) => String(v || '').trim().toLowerCase().replace(/\s+/g, ' ').replace(/[–—]/g, '-');
  const popup = document.querySelector(`#variant-popup-${productId}`);
  if (!popup) return;

  const colorInputs = popup.querySelectorAll('input.color-radio');
  let sourceLabel = null;
  const targetColor = norm(colorName);

  colorInputs.forEach((input) => {
    if (sourceLabel) return;
    const inputVal = norm(input.value);
    const label = input.nextElementSibling;
    const labelText = label ? norm(label.textContent) : '';
    if (inputVal === targetColor || labelText === targetColor) {
      sourceLabel = label;
    }
  });

  if (!sourceLabel) return;

  const applyStyle = (el) => {
    if (!el) return;
    el.removeAttribute('style');
    const sourceStyles = sourceLabel.style;
    for (let i = 0; i < sourceStyles.length; i++) {
      const propName = sourceStyles[i];
      el.style[propName] = sourceStyles.getPropertyValue(propName);
    }
  };

  const colorCircle = document.querySelector(`.active-color-info[data-product-id="${productId}"] .color-circle`);
  const colorCircleMob = document.querySelector(`.active-color-wrapper.on-mobile .active-color-info[data-product-id="${productId}"] .color-circle`);
  applyStyle(colorCircle);
  applyStyle(colorCircleMob);
};

window.byobSyncAllColorSwatches = function (context = document) {
  try {
    const buttons = context.querySelectorAll('.byobbtn[data-byob-product-id]');
    buttons.forEach((btn) => {
      const productId = btn.getAttribute('data-byob-product-id');
      const colorName = btn.dataset.colorName || '';
      if (!productId || !colorName) return;
      try {
        window.byobSyncColorSwatchStyle(productId, colorName);
      } catch (e) {
        // no-op per card
      }
    });
  } catch (e) {
    window.byobDebugLog('byobSyncAllColorSwatches failed', e);
  }
};

window.byobSyncAllGridSlides = function (context = document) {
  try {
    const buttons = context.querySelectorAll('.byobbtn[data-byob-product-id]');
    buttons.forEach((btn) => {
      const productId = btn.getAttribute('data-byob-product-id');
      if (!productId) return;

      const colorName = btn.dataset.colorName || '';
      const variantImageSrc = btn.dataset.variantImage || '';
      if (!colorName && !variantImageSrc) return;

      try {
        window.byobSlideGridToMatchingColor(productId, colorName, variantImageSrc);
      } catch (e) {
        // no-op per card
      }
    });
  } catch (e) {
    window.byobDebugLog('byobSyncAllGridSlides failed', e);
  }
};

window._byobGetActiveFilterValues = function () {
  const filters = { color: [], size: [] };
  const sizePattern = /size|taille|gr(o|ö)sse|st(o|ø)rrelse|koko|storlek/i;
  const colorPattern = /colour|color|couleur|farbe|farge|väri|färg/i;
  const normalize = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ').replace(/–/g, '-');

  const addFilter = (key, value) => {
    const normalized = normalize(value);
    if (!normalized) return;
    if (sizePattern.test(key)) filters.size.push(normalized);
    if (colorPattern.test(key)) filters.color.push(normalized);
  };

  try {
    const urlParams = new URLSearchParams(window.location.search);
    for (const [key, value] of urlParams.entries()) {
      if (!String(key).startsWith('filter.v.option.')) continue;
      addFilter(key, decodeURIComponent(value));
    }

    const formElements = document.querySelectorAll('#side-filter-form input:checked, #FilterDrawer .filter-form input:checked, #side-filter-form select, #FilterDrawer .filter-form select');
    formElements.forEach((el) => {
      const name = String(el.name || '');
      if (!name.startsWith('filter.v.option.')) return;
      if (el.tagName === 'SELECT' && el.value) {
        addFilter(name, el.value);
      } else if (el.checked && el.value) {
        addFilter(name, el.value);
      }
    });
  } catch (e) {
    window.byobDebugLog('byobGetActiveFilterValues failed', e);
  }

  return filters;
};

window.byobPersistedUserSelections = window.byobPersistedUserSelections || {};
window.byobSetPersistedUserSelection = function (productId, selection) {
  if (!productId || !selection) return;
  window.byobPersistedUserSelections = window.byobPersistedUserSelections || {};
  window.byobPersistedUserSelections[productId] = Object.assign({}, window.byobPersistedUserSelections[productId] || {}, selection);
};
window.byobGetPersistedUserSelection = function (productId) {
  window.byobPersistedUserSelections = window.byobPersistedUserSelections || {};
  return window.byobPersistedUserSelections[productId] || null;
};

window.byobAutoSelectFromVariantTitle = function (productId) {
  try {
    if (!productId) return;
    const popup = document.getElementById(`variant-popup-${productId}`);
    if (!popup) return;

    const gridItem = document.querySelector(`.grid__item[data-byob-product-id="${productId}"]`) || document.querySelector(`.grid__item[data-product-id="${productId}"]`);
    const source = (gridItem && (gridItem.querySelector('a.grid-product__link') || gridItem.querySelector('.byobbtn'))) || document.querySelector(`a.grid-product__link[data-product-id="${productId}"]`) || document.querySelector(`.byobbtn[data-byob-product-id="${productId}"]`);

    const rawVariantTitle = (source && (source.getAttribute('data-variant-title') || (source.dataset && source.dataset.variantTitle))) || '';
    const variantTitle = String(rawVariantTitle || '').trim();
    if (!variantTitle) return;

    const persistedSelection = typeof window.byobGetPersistedUserSelection === 'function'
      ? window.byobGetPersistedUserSelection(productId)
      : null;

    if (persistedSelection && (persistedSelection.color || persistedSelection.size)) {
      const normalize = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ').replace(/–/g, '-');
      if (persistedSelection.color) {
        const colorRadios = popup.querySelectorAll('input.color-radio');
        for (const r of Array.from(colorRadios)) {
          const val = normalize(r.value);
          const labelText = r.nextElementSibling ? normalize(r.nextElementSibling.textContent) : '';
          if (val === normalize(persistedSelection.color) || labelText === normalize(persistedSelection.color)) {
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }
      if (persistedSelection.size) {
        setTimeout(() => {
          const sizeRadios = popup.querySelectorAll('input.size-radio, input.variant-input-size-swatch');
          const normalizedSize = normalize(persistedSelection.size);
          for (const s of Array.from(sizeRadios)) {
            const sval = normalize(s.value);
            const lbl = popup.querySelector(`label[for="${s.id}"]`);
            const ltxt = lbl ? normalize(lbl.textContent) : '';
            if (sval === normalizedSize || ltxt === normalizedSize) {
              s.checked = true;
              s.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
        }, 50);
      }
      return;
    }

    const normalize = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ').replace(/–/g, '-');
    const parts = variantTitle.split('/').map(p => p.trim()).filter(Boolean);
    const colorPart = parts.length ? normalize(parts[0]) : '';
    const sizePart = parts.length > 1 ? normalize(parts[parts.length - 1]) : '';
    const activeFilters = window._byobGetActiveFilterValues();
    const colorCandidates = [...new Set([...(activeFilters.color || []), colorPart].filter(Boolean))];
    const sizeCandidates = [...new Set([...(activeFilters.size || []), sizePart, ...(parts.length > 2 ? [parts.slice(1).join(' / ')] : [])].filter(Boolean).map(normalize))];

    // Select color radio if present and if we have a filter or title candidate
    if (colorCandidates.length) {
      const colorRadios = popup.querySelectorAll('input.color-radio');
      for (const r of Array.from(colorRadios)) {
        const val = normalize(r.value);
        const labelText = r.nextElementSibling ? normalize(r.nextElementSibling.textContent) : '';
        if (colorCandidates.some(c => c === val || c === labelText)) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    }

    // Select size radio (wait a bit for color handlers to run)
    if (sizeCandidates.length) {
      setTimeout(() => {
        const sizeRadios = popup.querySelectorAll('input.size-radio, input.variant-input-size-swatch');
        for (const s of Array.from(sizeRadios)) {
          const sval = normalize(s.value);
          const lbl = popup.querySelector(`label[for="${s.id}"]`);
          const ltxt = lbl ? normalize(lbl.textContent) : '';
          if (sizeCandidates.some(c => c === sval || c === ltxt)) {
            s.checked = true;
            s.dispatchEvent(new Event('change', { bubbles: true }));
            const displayValue = lbl ? lbl.textContent.trim() : s.value;
            if (typeof window.byobUpdateCardSizeDisplay === 'function' && displayValue) {
              try { window.byobUpdateCardSizeDisplay(productId, displayValue); } catch (e) { /* ignore */ }
            }
            break;
          }
        }
      }, 50);
    }
  } catch (e) {
    window.byobDebugLog('byobAutoSelectFromVariantTitle failed', e);
  }
};

// Prepopulate BYOB add-button dataset attributes from a `data-variant-title` without opening popup
window.byobPrepopulateButtons = function (context = document) {
  try {
    const productCards = context.querySelectorAll('.product-card');
    productCards.forEach(card => {
      const productId = card.dataset.productCardId || card.getAttribute('data-byob-product-id') || card.getAttribute('data-product-id');
      if (!productId) return;

      const byobBtn = document.querySelector(`.byobbtn[data-byob-product-id="${productId}"]`) || card.querySelector('.byobbtn');
      const byobBtnProxy = document.querySelector(`.proxy-byob-button[data-byob-proxy-product-id="${productId}"]`) || card.querySelector('.proxy-byob-button');
      if (!byobBtn) return;

      const source = (card.querySelector('a.grid-product__link') || card.querySelector('.byobbtn')) || document.querySelector(`a.grid-product__link[data-product-id="${productId}"]`) || byobBtn;
      const rawVariantTitle = (source && (source.getAttribute('data-variant-title') || (source.dataset && source.dataset.variantTitle))) || '';
      if (!rawVariantTitle || typeof window.byobFindVariantByTitle !== 'function') return;

      const found = window.byobFindVariantByTitle(productId, rawVariantTitle);
      if (!found) return;

      try {
        byobBtn.dataset.variantId = found.id;
        byobBtn.dataset.price = found.price;
        byobBtn.dataset.variantImage = found.featured_image?.src || '';
        byobBtn.dataset.colorName = found.option1 || '';
        byobBtn.dataset.sizeName = found.option2 || '';
        try {
          window.byobSyncColorSwatchStyle(productId, byobBtn.dataset.colorName || '');
        } catch (e) {
          // no-op for prepopulation phase
        }
        try {
          window.byobSlideGridToMatchingColor(productId, byobBtn.dataset.colorName || '', byobBtn.dataset.variantImage || '');
        } catch (e) {
          // no-op for prepopulation phase
        }
        // mirror minimal data to proxy button if present
        if (byobBtnProxy) {
          byobBtnProxy.dataset.variantId = found.id;
          byobBtnProxy.dataset.price = found.price;
        }

        // update visible price element if present
        const priceElement = document.querySelector(`.grid-product__price[data-product-id="${productId}"] .grid-product__price--after`);
        if (priceElement) {
          priceElement.innerHTML = theme.Currency.formatMoney(found.price, theme.settings.moneyFormat);
        }

        // update product links to include variant parameter
        try { productUrlHandler(true, found.id); } catch (e) { /* ignore */ }
      } catch (e) {
        /* ignore per defensive approach */
      }
    });
  } catch (e) {
    window.byobDebugLog('byobPrepopulateButtons failed', e);
  }
};

// Try to find the best matching variant from productVariantsData by using variant title parts
window.byobFindVariantByTitle = function (productId, rawVariantTitle) {
  try {
    if (!productId || !rawVariantTitle) return null;
    const allProductVariantsData = window.productVariantsData || {};
    const variants = allProductVariantsData[productId] || allProductVariantsData[String(productId)] || [];
    if (!variants || !Array.isArray(variants)) return null;

    // Normalize helper
    const norm = str => (str || '').toString().trim().toLowerCase().replace(/\s+/g, ' ').replace(/–/g, '-').replace(/\s?cm\s?/g, 'cm');

    // Extract parts
    let parts = String(rawVariantTitle).split('/').map(p => p.trim()).filter(Boolean);
    if (parts.length <= 1) parts = String(rawVariantTitle).split('-').map(p => p.trim()).filter(Boolean);

    // Build candidates for size and color
    const colorCandidate = parts[0] ? norm(parts[0]) : '';
    let sizeCandidates = [];
    if (parts.length > 2) sizeCandidates.push(norm(parts.slice(1).join(' / ')));
    if (parts[1]) sizeCandidates.push(norm(parts[1]));
    if (parts.length > 0) sizeCandidates.push(norm(parts[parts.length - 1] || ''));
    sizeCandidates = sizeCandidates.filter(Boolean);

    // Try exact matches preferring available variants
    const scoreVariant = (v) => {
      const vColor = norm(v.option1);
      const vSize = norm(v.option2);
      let score = 0;
      if (colorCandidate && vColor === colorCandidate) score += 2;
      if (sizeCandidates.includes(vSize)) score += 3;
      if (v.available) score += 1;
      return score;
    };

    let best = null;
    let bestScore = -1;
    for (const v of variants) {
      const s = scoreVariant(v);
      if (s > bestScore) { bestScore = s; best = v; }
    }

    // Only return if some positive score
    return bestScore > 0 ? best : null;
  } catch (e) {
    return null;
  }
};

// Set the `.active-size-info strong` content directly from a data-variant-title (color / size) without opening popup
window.byobSetActiveSizeFromVariantTitle = function (productId) {
  try {
    if (!productId) return;
    const gridItem = document.querySelector(`.grid__item[data-byob-product-id="${productId}"]`) || document.querySelector(`.grid__item[data-product-id="${productId}"]`);
    const source = (gridItem && (gridItem.querySelector('a.grid-product__link') || gridItem.querySelector('.byobbtn'))) || document.querySelector(`a.grid-product__link[data-product-id="${productId}"]`) || document.querySelector(`.byobbtn[data-byob-product-id="${productId}"]`);
    const rawVariantTitle = (source && (source.getAttribute('data-variant-title') || (source.dataset && source.dataset.variantTitle))) || '';
    const variantTitle = String(rawVariantTitle || '').trim();
    if (!variantTitle) return;

    // split by '/' and fallback to common separators if needed
      let parts = variantTitle.split('/').map(p => p.trim()).filter(Boolean);
      if (parts.length <= 1) {
        // try other separators
        parts = variantTitle.split('-').map(p => p.trim()).filter(Boolean);
      }
      // Prefer combined size if there are more than 2 parts (e.g. Color / 15–16Y / 170cm)
      let sizePart = '';
      if (parts.length > 2) {
        sizePart = parts.slice(1).join(' / ');
      } else {
        sizePart = parts.length > 1 ? parts[1] : (parts[parts.length - 1] || '');
      }
      if (!sizePart) return;

      const normalized = sizePart.trim();
    const desktopStrong = document.querySelector(`.active-size-info.desktop[data-product-id="${productId}"] strong`);
    const popupStrong = document.querySelector(`.active-size-info[data-product-id="${productId}"] strong`);
    if (desktopStrong) desktopStrong.textContent = normalized;
    if (popupStrong) popupStrong.textContent = normalized;
  } catch (e) {
    window.byobDebugLog('byobSetActiveSizeFromVariantTitle failed', e);
  }
};